import axios from "axios";
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import $router from '@/router'
import store from '@/store'
import { createAxiosLoggerInterceptor } from '@cxcxcx/client-logger/axios'
import { logger } from '@/utils/logger'
const { onResponseError, onBusinessError } = createAxiosLoggerInterceptor(logger)
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000,
});
service.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = getToken()
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 200) {
      onBusinessError(res)
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      Message({
        message: res.msg,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject((new Error(res.msg || 'Error')))
    } else {
      return res
    }
  },
  error => {
    onResponseError(error)
    const res = error.response
    if (res.status === 401) {
      store.dispatch('resetToken')
      $router.push({ path: '/login' }).catch(e =>{ console.log(e) })
      Message({
        message: res.data.msg,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(error)
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
);
export default service;